import { render, staticRenderFns } from "./ExtratoFaturaEstorno.vue?vue&type=template&id=4ed56db8&scoped=true&"
import script from "./ExtratoFaturaEstorno.vue?vue&type=script&lang=js&"
export * from "./ExtratoFaturaEstorno.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoFaturaEstorno.vue?vue&type=style&index=0&id=4ed56db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed56db8",
  null
  
)

export default component.exports